"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HeaderComponent_1 = __importDefault(require("../../components/header/HeaderComponent"));
const notInitialized_1 = require("../../utils/notInitialized");
const ProfilePresenter_1 = __importDefault(require("./ProfilePresenter"));
const SearchPresenter_1 = __importDefault(require("./SearchPresenter"));
class HeaderPresenter {
    constructor(parentElement, tracks) {
        this.parentElement = parentElement;
        this.tracks = tracks;
        this.searchChangeCallback = notInitialized_1.notInitialized;
        this.headerComponent = new HeaderComponent_1.default();
        this.searchPresenter = this.render();
    }
    render() {
        this.headerComponent.removeElement();
        const headerElement = this.headerComponent.getElement();
        this.parentElement.prepend(headerElement);
        this.searchPresenter = new SearchPresenter_1.default(headerElement, this.tracks, 'header__search', 'header__search__field', 'ЧТО БУДЕМ ИСКАТЬ?', 'desktop-search');
        this.searchPresenter.searchChangeCallback = this.searchChangeCallback;
        new ProfilePresenter_1.default(headerElement);
        return this.searchPresenter;
    }
}
exports.default = HeaderPresenter;
